import { IUnits } from 'types/api';

export const getUnitsText = (units: IUnits): 'm' | 'in' | 'mm' => {
  if (units === 'metres') return 'm';
  if (units === 'mm') return 'mm';
  return 'in';
};
